<template>
  <b-container style="margin-top: 20px; " >

    <b-row v-if="isSendingRequest">
      <b-col>
        <img width="200px;" :src="Spinner" alt="l"/>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col>
        <FormulateForm  
          @submit="submitHandler"
          class="login-form"
          v-model="formValues"
          validation-behavior="submit"
          invalid-message="Email inválido"
          :form-errors="formErrors"
          :wrapper-class="['d-flex', 'justify-content-center']"
        >
        <h2>Esqueci minha senha</h2>
        <p>
          Por favor digite o email da sua conta para que possamos lhe enviar um link para reset de senha
        </p>
          <FormulateInput
            name="email"
            type="text"
            placeholder="Endereço de email"
            invalid-message="Email inválido"
            validation="email"
            :validation-messages="{
              email: 'Por favor digite um email válido',
            }"
          />

          <FormulateInput
            type="submit"
            label="Entrar"
            :disabled="!(formValues.email && formValues.email.length)"
          >
            Enviar email
          </FormulateInput>

          </FormulateForm>
      </b-col>
    </b-row>
  
  </b-container>
</template>

<script>
import Spinner from '../assets/images/Spinner-0.8s-200px.gif'
import Vue from  'vue'
import * as usersApiClient from "@/js/usersApiClient";

export default {
  name: 'PasswordForgotten',
  data() {
    return {
      formErrors: [],
       formValues: {
        email: '',
      },
      modalShow: false,
      isSendingRequest: false,
      Spinner,
    }
  },
  components: {
  
  },
  methods: {
    async submitHandler() {
      this.isSendingRequest = true;
      
      // Send request for password reset here
      const passwordResetResponse = await usersApiClient.requestPasswordResetAsync(this.formValues.email);
      
      this.isSendingRequest = false;

      if (passwordResetResponse.success) {
        Vue.$toast.success('Email de reset de senha enviado com sucesso.')
        await this.$router.push('/');
      }
      else {
        Vue.$toast.error('Erro ao enviar email de reset de senha. Por favor verifique se o email está correto.');
      }
    }
  }

}
</script>

<style>

</style>
